export default __webpack_public_path__ + "static/media/simone@3x.cb74e8a6.png";